import { useOnline } from '@/hooks/useOnline';

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div role="status" className="sticky top-0 z-20 bg-gold-100 px-4 py-2 pt-[calc(8px+env(safe-area-inset-top))] text-center text-sm font-semibold text-gold-800">
      Hors ligne — le calculateur de Zakat et les contenus déjà consultés restent disponibles.
    </div>
  );
}
